import script from "./ViewDeductionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDeductionPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewDeductionPage.vue?vue&type=style&index=0&id=4a3acb1d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a3acb1d"]])

export default __exports__